"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Icons = _interopRequireDefault(require("../baseComponents/Icons"));
var _FullBar = _interopRequireDefault(require("../baseComponents/FullBar"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Tile = function Tile(props) {
  //render
  var modalClasses = (0, _classnames["default"])(props.className, "tile-component", {
    "hasTileClick": !!props.onClick
  });
  var TitleTag = props.titleTag;
  function handleClick(e) {
    props.onClick && props.onClick(e, props.value);
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: modalClasses
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "imageContainer",
    "data-value": props.value,
    onClick: handleClick
  }, /*#__PURE__*/_react["default"].createElement("object", {
    className: "tileImg",
    data: props.imgUrl,
    type: "image/png",
    alt: props.alt
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
    name: "asset-glyph-images"
  }))), props.overlay && /*#__PURE__*/_react["default"].createElement("div", {
    className: "imageOverlay"
  }, /*#__PURE__*/_react["default"].createElement(_FullBar["default"], {
    right: [/*#__PURE__*/_react["default"].createElement(_Icons["default"], {
      name: props.overlay.iconName ? props.overlay.iconName : "icon-brick-editor",
      type: "framed-icon"
    }), /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
      className: "checkmark",
      name: "micro-glyph-checkmark",
      type: "framed-glyph"
    })]
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "tileDescription"
  }, props.title && /*#__PURE__*/_react["default"].createElement(TitleTag, null, props.title), props.desc && /*#__PURE__*/_react["default"].createElement("p", {
    className: "mice"
  }, props.desc), props.label && /*#__PURE__*/_react["default"].createElement("div", {
    className: "mice label"
  }, props.label)));
};
Tile.propTypes = {
  className: _propTypes["default"].string,
  imgUrl: _propTypes["default"].string,
  overlay: _propTypes["default"].shape({
    iconName: _propTypes["default"].string,
    actions: _propTypes["default"].shape({
      onClick: _propTypes["default"].func,
      label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object])
    })
  }),
  title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  desc: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  label: _propTypes["default"].object,
  onClick: _propTypes["default"].func,
  value: _propTypes["default"].string,
  // onclick data value
  titleTag: _propTypes["default"].oneOf(["h2", "h3", "h4", "h5"])
};
Tile.defaultProps = {
  titleTag: "h5"
};
var _default = exports["default"] = Tile;